import getEnvironment from '@bt-react/libs/getEnvironment'
import get from 'lodash/get'

const snapEngageKey = {
  stage: 'acdbe964-b8e6-4cf6-b6da-052980e45c82',
  prod: 'c123613c-0cdf-4472-afa7-f7fc5d5f5626'
}

const snapEngageConfig = () => {

  const env = get(getEnvironment(), 'env', '') === 'prod' ? 'prod' : 'stage'

  const key = snapEngageKey[ env ]

  return {
    url: `//storage.googleapis.com/code.snapengage.com/js/${key}.js`,
    key: key
  }

}

export default snapEngageConfig
